import {Component, Input} from '@angular/core';


@Component({
    selector: 'app-collection-label',
    templateUrl: './collection-label.component.html',
})

export class CollectionLabelComponent {
    @Input() items: object[] | string[];
    @Input() label: string;

    getLabel() {
        if (this.items?.length > 0) {
            if (this.items?.length > 1) {
                return this.items?.length;
            } else {
                return this.items[0][this.label] ? this.items[0][this.label] : this.items[0];
            }
        } else {
            return '-';
        }
    }
}
